module.exports = __webpack_public_path__ + "img/formula.9331c58e.png";